/**
 * PilotTipContainer component.
 */
import Screen from '@shared/utils/screen';
import styled from 'styled-components';

/**
 * Styled pilot tip container.
 */
const PilotTipContainer = styled.div<React.CSSProperties>`
position: absolute;
  bottom: ${42 * Screen.widthRatio}px;
  right: ${581 * Screen.widthRatio}px;
}
`;

export default PilotTipContainer;
